/* ab2026-21 · See the fit (test A/B por GrowthBook). Markup y contrato en
   snippets/ab2026-21-see-the-fit.liquid.

   Reparto: la flag `ab2026-21` (boolean) se evalúa cuando el ancla se acerca al viewport,
   y eso dispara la exposición. Antes, el estado cacheado de una visita anterior ya enseña
   la fila para que no aparezca de golpe. Sin SDK (sin consentimiento), control.

   Fila: suena un solo vídeo a la vez, 3 s cada uno, y cada vuelta sigue donde se quedó ese
   vídeo. Escritorio: bucle por los 4 primeros; el hover lo pausa y reproduce el de debajo
   del ratón sin límite, y al salir sigue por el siguiente. Móvil: recorre todos; si el
   siguiente no se ve entero, la fila se desliza hasta él, y del último vuelve al principio.
   Con el dedo en la fila no se mueve sola; al soltar sigue por uno que se vea. Solo corre
   con la fila en pantalla, la pestaña visible y el modal cerrado. Al pulsar, el modal
   compartido (LejLookModal). */
(function () {
  var CLAVE = 'ab2026-21';
  var root = document.querySelector('.ab2026-21-stf');
  var anchor = document.querySelector('.ab2026-21-stf-anchor');
  var modalEl = document.getElementById('ab2026-21-stf-modal');
  if (!root || !anchor || !modalEl) return;

  var cards = [].slice.call(root.querySelectorAll('.ab2026-21-stf__card:not([hidden])'));
  /* Sin vídeos tras el filtro de género: fuera del test, sin exposición. */
  if (!cards.length) return;

  var variante = null;
  var iniciado = false;

  function leerCache() { try { return localStorage.getItem(CLAVE); } catch (e) { return null; } }
  function guardarCache(v) { try { localStorage.setItem(CLAVE, String(v)); } catch (e) {} }

  function emitir(evento, extra) {
    var p = { 'ep.experiment_id': CLAVE, 'ep.variant': variante ? '1' : '0' };
    for (var k in extra) { if (extra[k] !== undefined && extra[k] !== '') p[k] = extra[k]; }
    if (typeof window.__lejEnviarGa4 === 'function') window.__lejEnviarGa4(evento, p);
    try { document.dispatchEvent(new CustomEvent('lej:' + CLAVE, { detail: { en: evento, params: p } })); } catch (e) {}
  }

  function fijar(v) {
    variante = v;
    root.hidden = !v;
    if (v) iniciar();
  }

  /* ---------- Reparto ---------- */
  var override = new URLSearchParams(location.search).get(CLAVE);
  if (override === '1' || override === '0') {
    guardarCache(override === '1');
    fijar(override === '1');
  } else {
    if (leerCache() === 'true') fijar(true);
    var decidido = false;
    var decidir = function () {
      if (decidido) return;
      decidido = true;
      window.growthbook_queue = window.growthbook_queue || [];
      window.growthbook_queue.push(function (gb) {
        var intentos = 0;
        (function pedir() {
          try {
            var idListo = typeof window.__lejFijarIdGb === 'function' && window.__lejFijarIdGb();
            var fs = typeof gb.getFeatures === 'function' ? gb.getFeatures() : null;
            if (idListo && fs && fs[CLAVE]) {
              var v = gb.getFeatureValue(CLAVE, false) === true;
              guardarCache(v);
              fijar(v);
              return;
            }
          } catch (e) { return; }
          if (intentos++ > 300) return;
          setTimeout(pedir, 100);
        })();
      });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); decidir(); }
      }, { rootMargin: '0px 0px 300px 0px' });
      io.observe(anchor);
    } else {
      decidir();
    }
  }

  /* ---------- Fila y modal (solo variante) ---------- */
  function iniciar() {
    if (iniciado) return;
    if (!window.LejLookModal) {
      document.addEventListener('lej:look-modal:ready', iniciar, { once: true });
      return;
    }
    iniciado = true;

    var SLOT_MS = 3000, LOOP_N = 4;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canHover = window.matchMedia('(hover: hover)').matches;
    var videos = cards.map(function (c) { return c.querySelector('video'); });
    var track = root.querySelector('.ab2026-21-stf__track');
    var loopVideos = videos.slice(0, LOOP_N);
    var str = (window.theme && window.theme.ab2026_21) || {};

    var modal = new LejLookModal(modalEl, {
      buyEnabled: true,
      strings: { edit: str.edit, info: str.info, soldOut: str.soldOut, selectSize: str.selectSize }
    });

    var items = cards.map(function (c) {
      var products = JSON.parse(c.querySelector('.products-data').textContent);
      return {
        media: '<video src="' + c.dataset.srcModal + '" poster="' + c.dataset.posterModal + '" muted playsinline></video>',
        title: products[0] ? products[0].title : '',
        products: products,
        /* `handle` no: el modal lo pinta como cuenta de Instagram. */
        productHandle: c.dataset.handle
      };
    });

    var idx = 0, timer = null, current = null, hovered = null, inView = false;
    var userHold = false, finger = false, auto = false, autoT = null;

    function fullyVisible(i) {
      var t = track.getBoundingClientRect(), r = cards[i].getBoundingClientRect();
      return r.width > 0 && r.left >= t.left - 1 && r.right <= t.right + 1;
    }

    /* Móvil: desliza la fila (no la página) hasta que la tarjeta i se vea entera, pegada a
       la derecha, en un punto de snap (inicio de tarjeta). */
    function reveal(i) {
      if (canHover || userHold || !track || fullyVisible(i)) return;
      var t = track.getBoundingClientRect(), right = cards[i].getBoundingClientRect().right, j = 0;
      while (j < i && right - cards[j].getBoundingClientRect().left > t.width + 1) j++;
      var left = track.scrollLeft + cards[j].getBoundingClientRect().left - t.left;
      if (Math.abs(left - track.scrollLeft) < 1) return;
      auto = true;
      track.scrollTo({ left: left, behavior: 'smooth' });
    }

    /* Al acabar un vídeo dentro de su turno vuelve a 0 y sigue: sin loop en la fila. */
    videos.forEach(function (v) {
      v.addEventListener('ended', function () {
        if (v === current) { v.currentTime = 0; v.play().catch(function () {}); }
      });
    });

    function play(v) {
      if (current && current !== v) current.pause();
      current = v;
      if (v.duration && v.currentTime >= v.duration - 0.1) v.currentTime = 0;
      v.preload = 'auto';
      var next = loopVideos[(loopVideos.indexOf(v) + 1) % loopVideos.length];
      if (next) next.preload = 'auto';
      v.play().catch(function () {});
    }

    function stop() {
      clearTimeout(timer);
      timer = null;
      if (current) current.pause();
      current = null;
    }

    function canRun() { return !reduce && inView && !document.hidden && !modal.isOpen && !hovered && !userHold && loopVideos.length; }

    function turn() {
      clearTimeout(timer);
      if (!canRun()) { stop(); return; }
      reveal(idx);
      play(loopVideos[idx]);
      timer = setTimeout(function () {
        idx = (idx + 1) % loopVideos.length;
        turn();
      }, SLOT_MS);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        turn();
      }, { threshold: 0.25 }).observe(root);
    } else {
      inView = true;
      turn();
    }
    document.addEventListener('visibilitychange', turn);

    /* Móvil: la cadena recorre todas. El scroll propio (`auto`) no cuenta como gesto; tras el
       del usuario (con inercia) sigue por la que sonaba si se ve, si no por la primera visible. */
    if (!canHover && track) {
      loopVideos = videos.slice();
      var settle = null;
      var resume = function () {
        clearTimeout(settle);
        if (finger) return;
        userHold = false;
        if (!fullyVisible(idx)) {
          var k = 0;
          while (k < cards.length && !fullyVisible(k)) k++;
          if (k < cards.length) idx = k;
        }
        stop();
        turn();
      };
      track.addEventListener('touchstart', function () { finger = userHold = true; auto = false; clearTimeout(settle); }, { passive: true });
      ['touchend', 'touchcancel'].forEach(function (ev) {
        track.addEventListener(ev, function () { finger = false; clearTimeout(settle); settle = setTimeout(resume, 150); }, { passive: true });
      });
      /* Con el dedo apoyado nunca se reanuda; tras soltar, se espera a que pare la inercia. */
      track.addEventListener('scroll', function () {
        if (auto) { clearTimeout(autoT); autoT = setTimeout(function () { auto = false; }, 200); return; }
        if (userHold && !finger) { clearTimeout(settle); settle = setTimeout(resume, 150); }
      }, { passive: true });
    }

    if (canHover && !reduce) {
      cards.forEach(function (c, i) {
        c.addEventListener('mouseenter', function () {
          hovered = videos[i];
          clearTimeout(timer);
          timer = null;
          if (!modal.isOpen) play(videos[i]);
        });
        c.addEventListener('mouseleave', function () {
          if (hovered !== videos[i]) return;
          hovered = null;
          stop();
          idx = (idx + 1) % loopVideos.length;
          turn();
        });
      });
    }

    cards.forEach(function (c, i) {
      c.addEventListener('click', function () { stop(); modal.open(items, i, c); });
    });
    modalEl.addEventListener('lej:look-modal:close', function () { hovered = null; turn(); });

    /* ---------- GA4 ---------- */
    modalEl.addEventListener('lej:look-modal:open', function (e) {
      emitir('stf_open', { 'ep.index': String(e.detail.index), 'ep.product': e.detail.item && e.detail.item.productHandle });
    });
    modalEl.addEventListener('lej:look-modal:add', function (e) {
      var item = e.detail.item || {};
      var card = modalEl.querySelector('.product-card[data-variant]');
      var size = '';
      if (card && item.products && item.products[0]) {
        item.products[0].variants.forEach(function (v) { if (String(v.id) === card.dataset.variant) size = v.title; });
      }
      emitir('stf_add', { 'ep.product': item.productHandle, 'ep.size': size });
    });
    /* `ended` no burbujea: se escucha en captura sobre el modal. */
    modalEl.addEventListener('ended', function (e) {
      if (e.target.tagName !== 'VIDEO' || !modal.isOpen) return;
      var item = modal.items && modal.items[modal.current];
      emitir('stf_complete', { 'ep.product': item && item.productHandle });
    }, true);
  }
})();
